const colorPalette = {
  baseBlue: '#00224c',
  baseGreen: '#009d00',
  hexDanger: '#FF0046',
  hexDangerOpa: '#FFF5F5',
  hexWarning: '#FFBC4F',
  hexWarningOpa: '#FFFAF3',
  hexSuccess: '#02D65F',
  hexSuccessOpa: '#CCF7DF',
  rgbError: 'rgba(255, 0, 70, 100)',
  rgbErrorOpa: 'rgba(255, 0, 70, 0.5)',
  rgbWarning: 'rgba(255, 127, 39, 100)',
  rgbWarningOpa: 'rgba(255, 127, 39, 0.5)',
  rgbSuccess: 'rgba(34, 177, 76, 100)',
  rgbSuccessOpa: 'rgba(34, 177, 76, 0.5)',
  TemporaryDepositReceived: '#2196F3',
  TemporaryDepositShipped: '#0E4498',
  TransportEntered: '#EC407A',
  TransportDelivered: '#651FFF',
  WarehouseReceived: '#F69B72',
  WarehouseShipped: '#C631E4',
  WarehouseReturned: '#5292FF',
  Projected: '#5f697a'
}

const dashboardFilterModes = {
  today: 'today',
  week: 'week',
  month: 'month',
  date: 'date'
}

const minimunValues = {
  success: 90,
  warning: 70
}

const defaultChartLabels = {
  day: [
    '12 am', '1 am', '2 am', '3 am', '4 am', '5 am', '6 am', '7 am', '8 am', '9 am', '10 am', '11 am',
    '12 pm', '1 pm', '2 pm', '3 pm', '4 pm', '5 pm', '6 pm', '7 pm', '8 pm', '9 pm', '10 pm', '11 pm'
  ],
  week: [
    'Lunes', 'Martes', 'Miécoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'
  ]
}

const defaultEriTypes = [
  {
    code: 'Cyclical',
    name: 'Eri Clíclico'
  },
  {
    code: 'Location',
    name: 'Eri Ubicaciones'
  },
  {
    code: 'Unit',
    name: 'Eri Unidades'
  }
]

const defaultSelectItem = {
  code: 'All',
  name: 'Todos'
}

const tableCSS = {
  table: {
    tableClass: 'table table-striped table-bordered table-hovered font-color-table'
  },
  pagination: {
    infoClass: 'pull-left',
    wrapperClass: 'vuetable-pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border btn-table',
    linkClass: 'btn btn-border btn-table',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: ''
    }
  }
}

const tableCSSOra = {
  table: {
    tableClass: 'table table-striped table-hovered font-color-table tr-ora'
  },
  pagination: {
    infoClass: 'pull-left',
    wrapperClass: 'vuetable-pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border btn-table',
    linkClass: 'btn btn-border btn-table',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: ''
    }
  }
}

const datePickerLocale = {
  format: 'DD/MM/YYYY',
  separator: ' - ',
  applyLabel: 'Aplicar',
  cancelLabel: 'Cancelar',
  fromLabel: 'De',
  toLabel: 'A',
  customRangeLabel: 'Custom',
  daysOfWeek: [
    'Do',
    'Lu',
    'Ma',
    'Mi',
    'Ju',
    'Vi',
    'Sa'
  ],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ],
  firstDay: 1
}

const ordersProgressFilterModes = {
  all: 'all',
  pending: 'pending',
  attended: 'attended'
}

const apiKeyGoogle = {
  /* -------------------- DEV -------------------- */
  /*
  vitz: 'AIzaSyCIqG0hqRtgVwAqlvUtqnzxni_nD2pVl2E',
  b2b: 'AIzaSyCIqG0hqRtgVwAqlvUtqnzxni_nD2pVl2E',
  b2c: 'AIzaSyDNbqxtkRoz1UejcvnHYPvjzOfZ__NvL-Q'
  */

  /* -------------------- TEST -------------------- */
  /*
  vitz: 'AIzaSyCYjRwVJO2jwb7xOoccVjtOFo7nh1YRREM',
  b2b: 'AIzaSyArtPY-pPYmLgeM9pLWZeSG7Csj0JoiMFU',
  b2c: 'AIzaSyDNbqxtkRoz1UejcvnHYPvjzOfZ__NvL-Q'
  */

  /* -------------------- PROD ------------------- */
  vitz: 'AIzaSyAcjXOjwuBVq-upuGUwYETmV_zBfvP-0tU',
  b2b: 'AIzaSyCbZMaTiXEYxdVyx0yyXg-DlDENsDI_ZoE',
  b2c: 'AIzaSyDNxfNwncTsa6kHs_oBZNsTqmb3WJc8-P8'
}

const defaultGeneral = {
  urlHelp: 'https://share.hsforms.com/1_m56eLa5QFixJW86gb7wpg4tj7e'
}

const ubigeoType = {
  departament: 'DEP',
  province: 'PROV',
  district: 'DIST'
}

/* Export */
export default {
  colorPalette,
  dashboardFilterModes,
  minimunValues,
  defaultChartLabels,
  defaultEriTypes,
  defaultSelectItem,
  tableCSS,
  datePickerLocale,
  ordersProgressFilterModes,
  apiKeyGoogle,
  defaultGeneral,
  ubigeoType,
  tableCSSOra
}



// WEBPACK FOOTER //
// ./src/assets/js/constants.js